import { createLogic } from 'state/defaultLogic';
import { instance as axios } from 'config/axios';
import { shouldFetch } from 'state/helpers';
import { APIGW_URL } from '../../constants/api';
import * as types from './types';
import * as actions from './actions';
import * as selectors from './selectors';

const SLICE_NAME = 'comments';

export const addCommentLogic = createLogic({
  type: types.ADD_COMMENT,
  process: async ({ getState, action }, dispatch, done) => {
    axios
      .post(
        `${APIGW_URL}/comments/${getState().auth.tenantID}/addcomment`,
        { ...action.payload, content: JSON.stringify(action.payload.content) },
        {
          headers: { Authorization: `Bearer ${getState().auth.tokens.access_token}` },
        },
      )
      .then(res => {
        const { result } = res.data;
        dispatch(actions.addedComment({ ...result, requestID: action.payload.requestID }));
      })
      .catch(e => {
        const errorPayload = { ...action.payload };
        if (e.response && e.response.data && e.response.data.error) {
          errorPayload.error = e.response.data.error;
        }
        dispatch(actions.errorTryAgainLater(errorPayload));
      })
      .then(() => done());
  },
});

export const getCommentsLogic = createLogic({
  type: types.FETCH_COMMENTS,

  validate({ getState, action }, allow, reject) {
    const state = getState();
    if (
      !!action.payload.nodeId &&
      shouldFetch(
        selectors.selectCommentsForNode(state.main[SLICE_NAME], action.payload.nodeId),
        state.main.connection,
        !!action.payload && action.payload.force,
      )
    ) {
      allow(action);
    } else {
      reject();
    }
  },

  process: async ({ getState, action }, dispatch, done) => {
    axios
      .get(`${APIGW_URL}/comments/${getState().auth.tenantID}/getcomments`, {
        params: { requestID: action.payload.requestID, target_node_id: action.payload.nodeId },
        headers: { Authorization: `Bearer ${getState().auth.tokens.access_token}` },
      })
      .then(res => {
        dispatch(
          actions.fetchedNodeComments({ ...res.data.result, nodeId: action.payload.nodeId }),
        );
      })
      .catch(() => {
        dispatch(actions.failedNodeComments(action.payload));
      })
      .then(() => done());
  },
});

export const editCommentLogic = createLogic({
  type: types.EDIT_COMMENT,
  process: async ({ getState, action }, dispatch, done) => {
    axios
      .post(
        `${APIGW_URL}/comments/${getState().auth.tenantID}/editcomment`,
        { id: action.payload.id, content: JSON.stringify(action.payload.content) },
        {
          headers: { Authorization: `Bearer ${getState().auth.tokens.access_token}` },
        },
      )
      .then(res => {
        const { result } = res.data;
        dispatch(actions.editedComment({ ...result, requestID: action.payload.requestID }));
      })
      .catch(e => {
        const errorPayload = { ...action.payload };
        if (e.response && e.response.data && e.response.data.error) {
          errorPayload.error = e.response.data.error;
        }
        dispatch(actions.errorTryAgainLater(errorPayload));
      })
      .then(() => done());
  },
});

export const deleteCommentLogic = createLogic({
  type: types.DELETE_COMMENT,
  process: async ({ getState, action }, dispatch, done) => {
    axios
      .post(
        `${APIGW_URL}/comments/${getState().auth.tenantID}/deletecomment`,
        { id: action.payload.id },
        {
          headers: { Authorization: `Bearer ${getState().auth.tokens.access_token}` },
        },
      )
      .then(res => {
        const { result } = res.data;
        dispatch(actions.deletedComment({ ...result, targetNodeId: action.payload.targetNodeId }));
      })
      .catch(e => {
        const errorPayload = { ...action.payload };
        if (e.response && e.response.data && e.response.data.error) {
          errorPayload.error = e.response.data.error;
        }
        dispatch(actions.errorTryAgainLater(errorPayload));
      })
      .then(() => done());
  },
});
